import { BlogArticleLocale } from "./BlogArticleContent";
import { BlogCategory } from "./BlogCategory";

export enum BlogArticleKey {
  CALL_ANALYSIS_TOOLS = "call-analysis-tools",
  MODJO_ALTERNATIVES = "modjo-alternatives",
  LEEXI_PRICING = "leexi-pricing",
  FREE_CALL_ANALYSIS = "free-call-analysis",
  CALL_RECORDING_GDPR = "call-recording-gdpr",
  SMALL_TEAM_CALL_ANALYSIS = "small-team-call-analysis",
  DISCOVERY_CALL = "discovery-call",
  DEMO_CALL = "demo-call",
  REALTIME_ANALYSIS = "realtime-analysis",
  WIN_LOSS_ANALYSIS = "win-loss-analysis",
  SALES_KNOWLEDGE_BASE = "sales-knowledge-base",
  OBJECTION_HANDLING = "objection-handling",
  SALES_CS_HANDOVER = "sales-cs-handover",
  MCP_SALES_CALLS = "mcp-sales-calls",
}

export type BlogArticle = {
  key: BlogArticleKey;
  slug: Record<string, string>;
  categoryId: BlogCategory;
  date: string;
  updated?: string;
  readTime: number;
  locales: Record<string, BlogArticleLocale>;
};
